import { Contact } from "types/auth";
import { EstateProps, MapProps, ProjectProps } from "types/estatesAndMap";

export interface GetContactOptions {
  userId: string | null;
  contacts: { [key: string]: Contact };
  selectedData: MapProps | ProjectProps | EstateProps | null;
  // selectedEstate?: EstateProps,
  // selectedProject?: ProjectProps,
  orgMapIds: string[];
  orgProjectIds: string[];
  personTypeLabelText: string;
  removeUserNotCreated?: boolean;
}

const getContactOptions = ({
  userId,
  contacts,
  selectedData,
  orgMapIds,
  orgProjectIds,
  personTypeLabelText,
  removeUserNotCreated = false,
}: GetContactOptions) => {
  if (contacts) {
    let contactArray: any[] = [];
    Object.entries(contacts).forEach(([id, el]: [string, Contact]) => {
      if (removeUserNotCreated && (!el.status || el.status !== "user-created")) {
        return;
      }
      let disabled = true;
      // Check for name in contact, else set to email
      let name = el.email;
      let nameAndOrgName = el.email;
      if (el.firstName && el.lastName) {
        name = `${el.firstName} ${el.lastName} (${el.email})`;
      }
      if (el.firstName && el.lastName) {
        nameAndOrgName = `${el.firstName} ${el.lastName}`;
        if (el.orgName) {
          nameAndOrgName += ` (${el.orgName})`;
        }
      }
      // Check if contact should be disabled based on selected data
      if (selectedData) {
        if (orgMapIds.includes(selectedData.id) || orgProjectIds.includes(selectedData.id)) {
          disabled = false;
        } else if (selectedData.roles && !selectedData.roles[el.id]) {
          disabled = false;
        } else if (selectedData.roles && selectedData.roles[el.id]) {
          if (selectedData.roles[el.id].inviterId === userId) {
            disabled = false;
          }
        }
      } else {
        disabled = false;
      }
      contactArray.push({
        ...el,
        id: id,
        name: name,
        nameAndOrgName: nameAndOrgName,
        label: name + ":" + el.email,
        personType: "contact" as any,
        personTypeLabelText,
        disabled,
      });
    });
    return contactArray;
  }
  return null;
};

export default getContactOptions;
